import React, { Component } from 'react';
import { isEmpty } from '../../Utilities/JsonFunctions.js';

declare var globalSns;
declare var globalExtranet;

class ExtranetTitle extends Component {
  render() {
    return (
      <section id="title" className="row title">
        <div>
          <h1>
            {
              isEmpty(this.props.className) ? 
                "" : 
                <i className={"fa " + this.props.className} aria-hidden="true"></i>
            }
            {this.props.title}
          </h1>
            {
              isEmpty(this.props.logoId) ?
                "" :
                <div className="image">
                  <img src={globalExtranet.extranetDocumentsUrl + "?id=" + this.props.logoId} alt={this.props.organisationName} />
                </div>
            }
        </div>
      </section>
    );
  }
}

export default ExtranetTitle;


// WEBPACK FOOTER //
// ./src/Components/Extranet/ExtranetTitle.js